export const URI = "https://goolg.com";
export const LIMIT = 50;
export const UPLOAD_CONST = "https://dermapuritys.com/php/upload.php";
